import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-OutdoorBillBoard",
  "use": "svg-icon-OutdoorBillBoard-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-OutdoorBillBoard\"><path d=\"M0 2h16v8H9.999L10 16H6v-6H0V2zm2 2v4h12V4H2z\" fill=\"#FFF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol